import fecha from 'fecha'

export default (input, format) => {
  if (!input) return

  const date = fecha.parse(input, format)
  if (!date) return

  const utcDate =
    date && new Date(date.getTime() - date.getTimezoneOffset() * 60000)

  return fecha.format(date, format) === input ? utcDate : undefined
}
